import {
  CAMPAIGN_PROMO,
  UPDATE_BIN,
  ALL_BINS,
  ALL_BIN_BATCH,
  UPDATE_ERR_BIN,
  ERR_BINS,
} from "../actions/actionTypes";

const initialState = {
  campaigns: [],
  binBatches: [],
  bins: [],
  errors: {},
  updateBin: {},
  loading: false,
};

export default function binsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CAMPAIGN_PROMO:
      return {
        ...state,
        campaigns: payload,
        loading: false,
      };
    case ALL_BIN_BATCH:
      return {
        binBatches: payload,
        loading: false,
      };
    case ALL_BINS:
      return {
        ...state,
        bins: payload,
        loading: false,
      };
    case UPDATE_BIN:
      return {
        ...state,
        updateBin: payload,
        loading: false,
      };
    case UPDATE_ERR_BIN:
      return {
        ...state,
        errors: payload,
        loading: false,
      };
    case ERR_BINS:
      return {
        ...state,
        errors: payload,
        loading: false,
      };
    default:
      return state;
  }
}
